module.exports = __webpack_public_path__ + "static/media/projects_image.8352a270.svg";